/**
 * NavigationList
 */
import React from 'react';
var renderChildren = function (children) {
    return React.Children.map(children, function (child, index) { return (React.createElement("li", { key: index, "data-cid": "NavigationListItem" }, React.cloneElement(child, child.props || {}))); });
};
/** Naviagation list with links. */
var NavigationList = function (_a) {
    var children = _a.children, className = _a.className, ariaLabel = _a["aria-label"];
    return (React.createElement("nav", { "aria-label": ariaLabel, className: className, "data-cid": "NavigationList" },
        React.createElement("ul", { className: "border-t-2 border-greyLight pt-8" }, renderChildren(children))));
};
export default NavigationList;
